/*
 * Módulo de frontend: página "Reportes Discord" (gestión: hilos nuevos, sin responder, por
 * validar, interacciones, tiempo dedicado...). Módulo hermano de `discord` (Menciones), que
 * no se toca.
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import AssessmentIcon from '@material-ui/icons/Assessment';

const discordReportsPage = PageBlueprint.make({
  name: 'discord-reports',
  params: {
    path: '/reportes-discord',
    title: 'Reportes Discord',
    icon: <AssessmentIcon />,
    loader: () => import('./DiscordReportsPage').then(m => <m.DiscordReportsPage />),
  },
});

export const discordReportsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [discordReportsPage],
});
